import { ActionTree } from 'vuex';

import { RootState } from '@/store/types';

import { subscribableStore } from './common';
import { SharedActivityTypesState } from './types';

const actions: ActionTree<SharedActivityTypesState, RootState> = {
  ...subscribableStore.actions,
};

export default actions;
